<template>
	<div class="container__crud">
		<div class="container__crudactions">
			<div class="container__crudactions__cruddownload">
				<div class="container__crudactions__cruddownload__crud">
					<Button
						:label="$t('deleteSelected')"
						color="trv-error"
						outlined
						icon="far fa-trash-alt"
						semantic-class="tiny"
						:disabled="isDeleteButtonDisabled"
						width-auto
						@click="toggleExclusionAlert"
					/>
					<Button
						:label="$t('create')"
						color="trv-default"
						semantic-class="tiny"
						width-auto
						@click="conscent ? handleContinue() : (beforeWeBegin = true)"
					/>
					<ExclusionAlert
						v-if="showExclusionAlert"
						:items-to-delete="modelList.filter((item) => item.isCheckedToDelete)"
						@cancel="toggleExclusionAlert"
						@confirm="deleteModels"
					>
						<template #item="{ item }">
							<li class="exclusion-alert-item">
								{{ $t('code') }} : {{ item.cbgm_cd_codigo }} - {{ $t('descricao') }} :
								{{ item.cbgm_ds_descricao }}
							</li>
						</template>
					</ExclusionAlert>
				</div>
				<!-- <div class="container__crudactions__cruddownload__download">
          <DownloadButton />
        </div> -->
			</div>
			<div class="container__crudactions__filtercollums">
				<div class="container__crudactions__filtercollums__filter">
					<InputSearch
						v-model="textFilter"
						style="margin-right: 0.5rem"
						:placeholder="$t('search')"
					/>
				</div>
				<div
					class="container__crudactions__filtercollums__collumns"
					style="display: flex"
				>
					<DropdownCheckbox v-model="tableHeaders" />
					<Button
						:label="$t('export')"
						semantic-class="mini"
						color="trv-primary"
						outlined
						width-auto
						style="border-radius: 5px !important; min-width: 65px"
						@click="downloadCSVCubagem()"
					/>
				</div>
			</div>
		</div>
		<CrudTable
			:headers="headersAtivos"
			:data="modelsToBeShowedAndTotal.items"
			:table-configuration="tableConfiguration"
			:show-edit-model-form="showEditModelForm"
			@sortConfig="
				sortBy = $event.sortBy
				sortType = $event.sortType
			"
		>
			<template #outer-action-button="dataObject">
				<KebabMenu
					v-model="intention"
					:options="kebabOptions"
					:properties="dataObject"
				/>
			</template>
		</CrudTable>
		<div class="container__crud__pagination">
			<Pagination
				ref="ref__pagination"
				:quantity-per-page="quantityPerPage"
				:quantity-per-page-options="[10, 20, 30]"
				:total-records="modelsToBeShowedAndTotal.total"
				@setStartEnd="setStartEnd"
				@setQuantityPerPage="setQuantityPerPage"
			/>
		</div>
		<CrudForm
			:is-visible="showForm"
			:change-is-visible="changeFormAndCloseAllActions"
			:title-form="titleForm"
			:backdrop="true"
		>
			<template #stepper>
				<div class="w-full flex justify-center mb-4">
					<RadialStepper
						v-model="step"
						:steps="[
							{ name: $t('cadastrarCubagem'), step: 1 },
							{ name: $t('mapProperties'), step: 2 },
							{ name: $t('summary'), step: 3 },
						]"
					/>
				</div>
			</template>
			<template #actions>
				<div class="py-4">
					<p class="!m-0">
						{{ $t('preenchaOsCampos') }}
					</p>
					<a
						@click="
							showForm = false
							beforeWeBegin = true
						"
						>{{ $t('verInstrucoes') }}</a
					>
				</div>
			</template>
			<template #form>
				<div style="display: flex; flex-direction: column; gap: 1rem">
					<InputText
						v-model="model.cbgm_ds_descricao"
						:label="$t('description') + '*'"
						@input="onDescriptionChange"
					/>
					<DropdownFk
						v-model="model.fk_fzda_fazenda"
						:label="$t('farm') + '*'"
						:dropdown-options="fazendas"
					/>

					<FileUpload
						v-if="!isEdit"
						extensions-accepted=".csv"
						:disabled="!plantios.length"
						:label="$t('selecioneArquivoCubagem')"
						@onUpload="handleFileUpload($event)"
					/>

					<p
						v-show="erroLeituraArquivo || content.errors.length"
						style="
							background-color: var(--color-error-background);
							width: 100%;
							padding: 0.3rem;
							border-radius: 5px;
							color: white;
						"
					>
						{{ erroLeituraArquivo || $t('badCsvImport') }}
					</p>

					<div class="container__crud__crudform__buttons">
						<Button
							v-if="!isEdit"
							:label="$t('import') + ' ' + $t('logging')"
							color="trv-default"
							semantic-class="mini"
							:disabled="isDisabled"
							@click="
								enableFileUpload = true
								showForm = false
								step = 2
							"
						/>
						<Button
							v-else
							:label="$t('export')"
							color="trv-default"
							semantic-class="mini"
							@click="exportar"
						/>
						<Button
							v-if="descriptionChanged"
							:label="$t('save')"
							color="trv-default"
							@click="saveClick"
						/>
					</div>
				</div>
			</template>
		</CrudForm>
		<Modal
			v-if="enableFileUpload"
			align="up"
			style="background-color: white"
		>
			<div
				style="
					margin-top: 1rem;
					height: fit-content;
					/* margin: auto 0; */
					top: 80px;
					width: 80vw;
					padding: 1rem;
					border-radius: 10px;
				"
			>
				<div>
					<div class="w-full justify-center flex mb-4">
						<BreadCrumb
							v-model="step"
							:crumbs="[
								{ name: $t('cadastrarCubagem'), step: 1 },
								{ name: $t('mapProperties'), step: 2 },
								{ name: $t('summary'), step: 3 },
							]"
						/>
					</div>
					<DataMapper
						v-if="step === 2"
						v-model="colunaAtributo"
						:filename="file.name"
						:data="medicoesNormalizadas"
						:colunas="colunasMapeamento"
						@next="step++"
						@previous="step--"
						@change="handleFileUpload($event)"
						@cellChanged="handleCellChanged"
						@close="
							enableFileUpload = false
							showForm = true
						"
						@done="saveClick"
					>
						<template #finally>
							<div style="display: flex; justify-content: space-evenly; padding: 2rem 0">
								<KPI
									:description="$t('tree')"
									:value="totalArvores"
								/>
								<KPI
									:description="$t('plantation')"
									:value="totalPlantios"
								/>
								<KPI
									:description="$t('section')"
									:value="totalTalhoes"
								/>
								<KPI
									:description="$t('hbdavg')"
									:value="mediaDAP.toFixed(2)"
								/>
								<KPI
									:description="`${$t('ht')} ${$t('average')}`"
									:value="mediaHT.toFixed(2)"
								/>
								<KPI
									:description="`${$t('age')} ${$t('average')}`"
									:value="mediaIdade.toFixed(1)"
								/>
							</div>
						</template>
						<template #action-finally>
							<Button
								style="float: right"
								:loading="salvando"
								width-auto
								outlined
								lefticon="fas fa-check"
								color="trv-default"
								:label="`${$t('import')} ${$t('measurement')}`"
								@click="saveClick"
							/>
						</template>
					</DataMapper>
					<Button
						v-if="step === 2"
						class="float-right mt-4"
						width-auto
						icon="fas fa-arrow-right"
						color="trv-default"
						:label="$t('continue')"
						@click="avancarEtapa"
					/>
					<div v-if="step === 3">
						<div style="display: flex; gap: 1rem">
							<i
								style="font-size: 1rem; height: fit-content; margin: auto 0; cursor: pointer"
								class="fas fa-arrow-left"
								@click="step = 2"
							/>
							<h1 style="margin: 0">
								{{ $t('summary') }}
							</h1>
						</div>
						<p>{{ `${$t('these')} ${medicoesNormalizadas.length} ${$t('referTo')}` }}:</p>
						<div style="display: flex; justify-content: space-evenly; padding: 2rem 0">
							<KPI
								:description="$t('tree')"
								:value="totalArvores"
							/>
							<KPI
								:description="$t('plantation')"
								:value="totalPlantios"
							/>
							<KPI
								:description="$t('section')"
								:value="totalTalhoes"
							/>
							<KPI
								:description="$t('hbdavg')"
								:value="mediaDAP.toFixed(2)"
							/>
							<KPI
								:description="`${$t('ht')} ${$t('average')}`"
								:value="mediaHT.toFixed(2)"
							/>
							<KPI
								:description="`${$t('age')} ${$t('average')}`"
								:value="mediaIdade.toFixed(1)"
							/>
						</div>
						<Button
							style="float: right"
							:loading="salvando"
							width-auto
							lefticon="fas fa-check"
							color="trv-default"
							:label="`${$t('import')} ${$t('logging')}`"
							@click="saveClick"
						/>
					</div>
				</div>
			</div>
		</Modal>
		<InstrucaoMedicao
			v-show="beforeWeBegin"
			chave="cubagem"
			:colunas="colunasMapeamento"
			@continue="handleContinue"
			@previous="handlePrevious"
		/>
	</div>
</template>

<script>
import { useLocalStorage } from '@vueuse/core'
import download from 'downloadjs'
import { exportarCsv } from '../../../../utils/csvHellpers'

import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'

import Button from '../../../../components/Button/Button'
import CrudForm from '../../../../components/CrudForm/CrudForm'
import CrudTable from '../../../../components/CrudTable/CrudTable'
// import DownloadButton from "../../../../components/DownloadButton/DownloadButton";
import BreadCrumb from '../../../../components/BreadCrumb/BreadCrumb'
import DataMapper from '../../../../components/DataMapper/DataMapper'
import DropdownCheckbox from '../../../../components/DropdownCheckbox/DropdownCheckbox'
import DropdownFk from '../../../../components/DropdownFk/DropdownFk'
import FileUpload from '../../../../components/FileUpload/FileUpload'
import InputSearch from '../../../../components/InputSearch/InputSearch'
import InputText from '../../../../components/InputText/InputText'
import InstrucaoMedicao from '../../../../components/InstrucaoMedicao/InstrucaoMedicao'
import KPI from '../../../../components/KPI/KPI'
import KebabMenu from '../../../../components/KebabMenu/KebabMenu'
import Modal from '../../../../components/Modal/Modal'
import Pagination from '../../../../components/Pagination/Pagination'
import RadialStepper from '../../../../components/RadialStepper/RadialStepper'

import ControllingPaginationMixins from '../../../../mixins/ControllingPaginationMixins'
import MedicoesCubagemMixins from '../../../../mixins/MedicoesCubagemMixins'
import RegistersMixins from '../../../../mixins/RegistersMixins'

import {
	buscaCubagemParaExportacao,
	createCubagem,
	deleteCubagemByIdList,
	getAllCubagens,
	importarCSVCubagem,
	updateCubagem,
} from '../../../../services/requests/CubagemRequests'

import { getDropdownFazendas } from '../../../../services/requests/FazendaRequests'
import ExclusionAlert from '../../../../components/ExclusionAlert/ExclusionAlert.vue'

export default {
	components: {
		KPI,
		FileUpload,
		DataMapper,
		Button,
		CrudForm,
		CrudTable,
		// DownloadButton,
		DropdownCheckbox,
		InputSearch,
		InputText,
		Pagination,
		DropdownFk,
		KebabMenu,
		Modal,
		InstrucaoMedicao,
		BreadCrumb,
		RadialStepper,
		ExclusionAlert,
	},
	/**
	 * Mixins
	 * - ControllingPaginationMaxins: Mixin para controler a paginacao
	 * - RegistersMixins: Mixin com funções compartilhadas para realizar o CRUD
	 */
	mixins: [ControllingPaginationMixins, RegistersMixins, MedicoesCubagemMixins],
	data() {
		return {
			step: 1,
			beforeWeBegin: false,
			salvando: false,
			descriptionChanged: false,
			showExclusionAlert: false,
			initialDescription: '',
			dadosExport: [],
			novaMedicao: {
				talhao: '',
				plantio: '',
				arvore: '',
				dap: '',
				dicc: '',
				ht: '',
				espessuraCasca: '',
				hi: '',
				idade: '',
				matgen: '',
			},
			enableFileUpload: false,
			intention: {},
			headersSelecionados: [
				'cbgm_ds_descricao',
				'medicao',
				'ordemDeServico',
				'fazenda',
				'cbgm_cd_codigo',
			],
			disableContinue: false,
			/**
			 * Configuração da tabela
			 */
			tableConfiguration: {
				prefix: 'CB-',
				statusTable: this.$t('loading') + '...',
				subtitleCardPropertie: 'cbgm_ds_descricao',
				titleCardPropertie: 'cbgm_cd_codigo',
			},
			tableHeaders: [
				{ key: 'cbgm_cd_codigo', value: this.$t('code'), isActive: true },
				{ key: 'fazenda', value: this.$t('farm'), isActive: true },
				{
					key: 'ordemDeServico',
					value: this.$t('serviceOrder'),
					isActive: true,
				},
				{ key: 'medicao', value: this.$t('measurement'), isActive: true },
				{
					key: 'cbgm_ds_descricao',
					value: this.$t('description'),
					isActive: true,
				},
				{
					key: 'cbgm_dt_afericao',
					value: this.$t('admeasurementDate'),
					isActive: false,
				},
			],
			fazendas: [],
		}
	},
	computed: {
		conscent() {
			return JSON.parse(useLocalStorage('conscent-cubagem', false).value)
		},
		totalArvores() {
			return Object.keys(_.groupBy(this.medicoesNormalizadas, this.bindColunas.arvore)).length
		},
		totalTalhoes() {
			return Object.keys(_.groupBy(this.medicoesNormalizadas, this.bindColunas.talhao)).length
		},
		totalPlantios() {
			return Object.keys(_.groupBy(this.medicoesNormalizadas, this.bindColunas.plantio)).length
		},
		totalSeccoes() {
			return Object.keys(_.groupBy(this.medicoesNormalizadas, this.bindColunas.htSeccao)).length
		},
		mediaDAP() {
			return (
				this.medicoesNormalizadas
					.map((m) => Number(m[this.bindColunas.dap].replace(',', '.')))
					.reduce((a, b) => a + b, 0) / this.medicoesNormalizadas.length || 0
			)
		},
		mediaHT() {
			return (
				this.medicoesNormalizadas
					.map((m) => Number(m[this.bindColunas.ht].replace(',', '.')))
					.reduce((a, b) => a + b, 0) / this.medicoesNormalizadas.length || 0
			)
		},
		mediaIdade() {
			return (
				this.medicoesNormalizadas
					.map((m) => Number(m[this.bindColunas.idade].replace(',', '.')))
					.reduce((a, b) => a + b, 0) / this.medicoesNormalizadas.length || 0
			)
		},
		novoRegistroFormatado() {
			return {
				[this.bindColunas.talhao]: this.novaMedicao.talhao,
				[this.bindColunas.plantio]: this.novaMedicao.plantio,
				[this.bindColunas.arvore]: this.novaMedicao.arvore,
				[this.bindColunas.dap]: this.novaMedicao.dap,
				[this.bindColunas.dicc]: this.novaMedicao.dicc,
				[this.bindColunas.ht]: this.novaMedicao.ht,
				[this.bindColunas.espessuraCasca]: this.novaMedicao.espessuraCasca,
				[this.bindColunas.htSeccao]: this.novaMedicao.hi,
				[this.bindColunas.idade]: this.novaMedicao.idade,
				[this.bindColunas.matgen]: this.novaMedicao.matgen,
			}
		},
		isFilled() {
			return Object.values(this.novaMedicao).every((value) => value != '')
		},
		isDisabled() {
			return !this.camposObrigatoriosPreenchidos && !this.content.errors.length
		},
		kebabOptions() {
			return [
				{
					value: 'editar',
					label: this.$t('edit'),
				},
			]
		},
		headersAtivos() {
			const ativos = this.tableHeaders.filter((f) => this.headersSelecionados.includes(f.key))

			ativos.forEach((f) => {
				f.isActive = true
			})

			return ativos
		},
		/**
		 * Retorna se os campos obrigatórios estão preenchidos
		 */

		camposObrigatoriosPreenchidos() {
			const obrigatorios = this.model.fk_fzda_fazenda && this.model.cbgm_ds_descricao

			if (this.isEdit) {
				return obrigatorios
			} else {
				// `parsed` além de `file`: quando a leitura falha (encoding não
				// suportado, por exemplo) o arquivo está selecionado mas não há
				// conteúdo, e liberar o botão levava o usuário para a etapa de
				// mapeamento com a grid vazia.
				return obrigatorios && this.file && this.parsed
			}
		},
	},
	watch: {
		step(value) {
			if (value === 1) {
				this.enableFileUpload = false
				this.showForm = true
			}
		},
		tableHeaders: {
			deep: true,
			handler(value) {
				this.headersSelecionados = value.filter((f) => f.isActive).map((m) => m.key)
			},
		},

		intention(value) {
			const model = this.modelList.find((model) => {
				return model.id === value.properties.id
			})

			switch (value.intent) {
				case 'editar':
					this.showEditModelForm(model)
					break
			}
		},
	},
	/**
	 * Antes de criar o objeto seta a quantidade de itens por pagina
	 * e a ordenacao da tabela
	 */
	async created() {
		this.fazendas = await getDropdownFazendas()

		this.quantityPerPage = 10
		this.atualEndIndex = 10
		this.orderTable = ['cbgm_cd_codigo']
		getAllCubagens().then((response) => {
			const { result: cubagens } = response.data
			cubagens.forEach((cubagem) => this.formataCubagemParaCrud(cubagem))
			this.modelList = cubagens
			this.tableConfiguration.statusTable = this.$t('noRecordFound')
		})
	},
	methods: {
		toggleExclusionAlert() {
			this.showExclusionAlert = !this.showExclusionAlert
		},

		onDescriptionChange(value) {
			if (this.isEdit) {
				this.descriptionChanged = this.initialDescription !== value
			}
		},
		avancarEtapa() {
			// Antes de continuar com a importação, precisamos checar se os dados que estão no banco existem no CSV
			if (this.step == 2) {
				if (this.validarMapeamento() == true) {
					return
				}
				var plantiosCSV = Array.from(
					new Set([...this.medicoesNormalizadas.map((m) => m[this.bindColunas.plantio])]),
				)
				var materiaisGeneticosCSV = Array.from(
					new Set([...this.medicoesNormalizadas.map((m) => m[this.bindColunas.matgen])]),
				)
				// Verifica se existem pelo menos um  dos plantios e todos os  materiais geneticos do CSV existe no banco
				var existemPeloMenosUmPlantio = plantiosCSV.some((plantioCSV) =>
					this.plantios.includes(plantioCSV),
				)
				var existemTodosOsMateriaisGeneticos = materiaisGeneticosCSV.every((materialGeneticoCSV) =>
					this.materiaisGeneticos.includes(materialGeneticoCSV),
				)

				if (existemPeloMenosUmPlantio && existemTodosOsMateriaisGeneticos) {
					this.content.data = this.content.data.filter((plantio) =>
						this.plantios.includes(plantio[this.bindColunas.plantio]),
					)
					this.step++
					return
				} else {
					let mensagem = ''
					if (!existemPeloMenosUmPlantio) {
						mensagem = 'Nenhum dos plantios esta cadastrado no banco de dados!'
					} else {
						mensagem = 'Existem materiais genéticos que não estão cadastrados!'
					}
					this.mutationShowMessage({
						messageTitle: this.$t('aviso'),
						messageText: mensagem,
						messageIcon: 'far fa-check-circle',
						messageType: 'warning',
					})
					return
				}
			}
		},

		downloadCSVCubagem() {
			let cabecalhoDoCsvCubagem = [
				'Código',
				'Fazenda',
				'Ordem de Serviço',
				'Medição',
				'Descrição',
				'Data de Aferição',
			]
			const items = this.modelList

			const linhas = items.map((item) => [
				item.cbgm_cd_codigo,
				item.fazenda,
				item.ordemDeServico,
				item.medicao,
				item.mdco_ds_descricao,
				item.cbgm_dt_afericao,
			])

			exportarCsv('export_cubagem', cabecalhoDoCsvCubagem, linhas)
		},

		validarMapeamento() {
			let values = this.$data.content.data
			let erro

			for (const coluna of values) {
				if (coluna.inconsistencias && coluna.inconsistencias.length > 0) {
					coluna.inconsistencias = coluna.inconsistencias.filter(
						(inconsistencia) =>
							!inconsistencia.startsWith('Sistema não possui plantio com código:'),
					)
					// Verifica se há pelo menos um plantio em comum
					const hasCommonPlantio = this.plantios.some((plantio) => coluna.Plantio.includes(plantio))

					if (hasCommonPlantio) {
						// Se houver pelo menos um plantio em comum, remove todas as inconsistências com a string "A medição não inclui nenhum plantio da fazenda"
						coluna.inconsistencias = coluna.inconsistencias.filter(
							(inconsistencia) =>
								inconsistencia !== 'A medição não inclui nenhum plantio da fazenda',
						)
					}

					if (coluna.inconsistencias.length > 0) {
						erro = `Realize o ajuste das seguintes inconsistências: ${coluna.inconsistencias.join(', ')}`
					}
				}
			}

			if (erro) {
				console.log(`Erro encontrado: ${erro}`)
				this.disableContinue = true
				this.mutationShowMessage({
					messageTitle: this.$t('aviso'),
					messageText: `Atenção! ${erro}`,
					messageIcon: 'far fa-check-circle',
					messageType: 'warning',
				})
				return true
			} else {
				this.disableContinue = false
				return false
			}
		},

		handleCellChanged(value) {
			const registro = this.medicoesNormalizadas.find((e) => e.id === value.id)
			const index = this.medicoesNormalizadas.indexOf(registro)
			this.medicoesNormalizadas.splice(
				index,
				1,
				Object.assign(this.medicoesNormalizadas[0], { [value.key]: value.value }),
			)
		},
		handleContinue() {
			this.showNewModelForm()
			this.beforeWeBegin = false
		},
		handlePrevious() {
			this.beforeWeBegin = false
		},
		exportar() {
			const header = [
				this.$t('farm'),
				this.$t('talhoes'),
				this.$t('planting'),
				this.$t('idadeAno'),
				this.$t('geneticMaterial'),
				this.$t('tree'),
				this.$t('hbdcm'),
				this.$t('ht'),
				this.$t('hi'),
				this.$t('hi_esperado'),
				this.$t('dicc'),
				this.$t('barkThickness'),
				this.$t('coordinateX'),
				this.$t('coordinateY'),
			]
			const csv = [
				header, // header row first
				...this.dadosExport.map((row) =>
					Object.keys(this.dadosExport[0]).map((fieldName) => {
						if (!isNaN(row[fieldName])) {
							return Number(row[fieldName]).toString().replace('.', ',')
						}
						return row[fieldName]
					}),
				),
			]
				.map((m) => m.join(';'))
				.join('\r\n')

			download(csv, this.model.cbgm_ds_descricao + '.csv', 'text/csv')
		},
		adicionaNovoRegistro() {
			this.content.data.push(Object.assign(this.novoRegistroFormatado, { id: uuidv4() }))

			this.mutationShowMessage({
				messageTitle: this.$t('sucesso'),
				messageText: this.$t('registroAdicionadoComSucesso'),
				messageIcon: 'far fa-check-circle',
				messageType: 'success',
			})
		},
		/**
		 * O DataMapper emite `change` para dois casos diferentes: a troca do
		 * arquivo ("Substituir medição"), que manda o File, e o rebind de uma
		 * coluna no dropdown, que manda o array de colunaAtributo. Sem checar o
		 * tipo, remapear a coluna de Talhão/Plantio sobrescrevia `file` com o
		 * array e reparseava — perdendo o nome do arquivo e o conteúdo lido.
		 */
		handleFileUpload(event) {
			if (!(event instanceof File)) return

			this.file = event
			this.parseFile()
		},
		setColunaAtributo(e) {
			this.colunaAtributo = e
		},
		/**
		 * Cria o objeto que deve ser enviado para o backend para ser
		 * criado no banco de dados
		 */
		createCubagemToPost() {
			return {
				id: uuidv4(),
				cbgm_ds_descricao: this.model.cbgm_ds_descricao,
				cbgm_dt_afericao: new Date(),
				fk_fzda_fazenda: this.model.fk_fzda_fazenda,
				fk_orsv_ordem_servico: this.model.fk_orsv_ordem_servico,
				fk_mdco_medicao: this.model.fk_mdco_medicao,
			}
		},

		/**
		 * Formata campos de cubagem para exibir na tabela de crud
		 */
		formataCubagemParaCrud(cubagem) {
			cubagem.isCheckedToDelete = false
		},

		/**
		 * Cria nova cubagem no banco de dados
		 */
		create() {
			this.salvando = true

			const cubagem = this.createCubagemToPost()

			createCubagem(cubagem).then(async (response) => {
				const { result: cubagem, isError } = response.data
				this.disableSaveButton = false
				console.log(cubagem)

				if (!isError) {
					// this.cleanModel();
					this.formataCubagemParaCrud(cubagem)
					this.modelList.unshift(cubagem)
					this.showForm = false
					this.emptyValue = ''

					await importarCSVCubagem({
						cubagemId: cubagem.id,
						plantios: this.medicoesAgrupadasPorPlantioArvoreSeccao,
					})
					this.enableFileUpload = false
					this.showForm = false
					this.salvando = false
					// this.step = 1;

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.step = 1
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Atualiza cubagem no banco de dados
		 */
		update() {
			updateCubagem(this.model).then((response) => {
				const { result: cubagem, isError } = response.data
				this.disableSaveButton = false
				this.descriptionChanged = false
				if (!isError) {
					this.formataCubagemParaCrud(cubagem)

					const indexCubagem = this.modelList
						.map((cubagemModelList) => cubagemModelList.id)
						.indexOf(cubagem.id)
					this.$set(this.modelList, indexCubagem, cubagem)

					this.showForm = false

					this.mutationShowMessage({
						messageTitle: this.$t('sucesso'),
						messageIcon: 'far fa-check-circle',
						messageType: 'success',
					})
				} else {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				}
			})
		},

		/**
		 * Exclui cubagem no banco de dados
		 */
		deleteModels(email) {
			var emailUsuario = localStorage.getItem('email')
			if (email === emailUsuario) {
				const existeRegistroComDependencia = this.modelList.filter(
					(cubagem) =>
						this.modelsIdWithCheckedToDelete.includes(cubagem.id) &&
						cubagem.possuiDependenciaDeRegistro,
				)
				if (existeRegistroComDependencia.length == 0) {
					const confirmResult = confirm(this.$t('confirmaExclusao'))

					if (confirmResult) {
						deleteCubagemByIdList(this.modelsIdWithCheckedToDelete).then(() => {
							this.modelsIdWithCheckedToDelete.forEach((f) => {
								const indexToRemove = this.modelList.map((m) => m.id).indexOf(f)
								this.modelList.splice(indexToRemove, 1)
							})

							this.mutationShowMessage({
								messageTitle: this.$t('sucesso'),
								messageIcon: 'far fa-check-circle',
								messageType: 'success',
							})
							this.showExclusionAlert = false
						})
					}
				} else {
					var medicoesOrganizadas = existeRegistroComDependencia
						.map((cubagem) => `• CB-${cubagem.cbgm_cd_codigo} -  ${cubagem.cbgm_ds_descricao}`)
						.join('<br/>')
					var message = `<b>${this.$t('dependenciaDeArvoresCubadas')}:</b> <br/><br/> ${medicoesOrganizadas}`
					this.mutationShowMessage({
						messageTitle: this.$t('cuidado'),
						messageText: message,
						messageIcon: 'fas fa-exclamation-circle',
						messageType: 'warning',
					})
				}
			} else {
				this.mutationShowMessage({
					messageTitle: this.$t('wrongEmail'),
					messageIcon: 'fas fa-lock',
					messageType: 'error',
					messageText: this.$t('wrongEmaildescricao'),
				})
			}
		},

		/**
		 * Método executado quando clica no botão de salvar
		 */
		saveClick() {
			this.disableSaveButton = true
			if (this.isEdit) {
				this.update()
			} else {
				this.create()
			}
		},

		/**
		 * Configura para exibir o Model de edicao
		 */
		async showEditModelForm(model) {
			this.model = Object.assign({}, model)
			this.initialDescription = this.model.cbgm_ds_descricao
			this.titleForm = `${this.$t('edit')} ${this.$t('logging')}`
			this.isEdit = true
			this.changeFormAndCloseAllActions()
			this.dadosExport = []
			try {
				const dadosExportacao = await buscaCubagemParaExportacao(model.id)
				this.dadosExport = dadosExportacao.data.result
			} catch {
				this.mutationShowMessage({
					messageTitle: this.$t('erro'),
					messageText: this.$t('erroAoBuscarDadosExportacao'),
					messageIcon: 'far fa-check-circle',
					messageType: 'error',
				})
			}
		},

		/**
		 * Configura para exibir o Model de Cadastro
		 */
		showNewModelForm() {
			this.cleanModel()

			this.titleForm = `${this.$t('create')} ${this.$t('logging')}`
			this.isEdit = false
			this.changeFormAndCloseAllActions()
		},

		/**
		 * Fecha o formulario e actions que estiverem abertas
		 */
		changeFormAndCloseAllActions() {
			this.showForm = !this.showForm
		},
	},
}
</script>

<style scoped src="../../../../css/crud.css"></style>
